<template>
  <div class="form-element">
    <slot></slot>
    <div v-if="tooltipContent" class="form-element__tooltip">
      <sanitas-tooltip
        :content="tooltipContent"
        :label="tooltipLabel"
        tabindex="-1"
      />
    </div>
    <form-input-error :errors="errors" class="form-element__errors" />
  </div>
</template>

<script>
import SanitasTooltip from '@/modules/forms/components/SanitasTooltip'

import FormInputError from './sanitas-components/FormInputError'

export default {
  name: 'FormElement',
  components: { SanitasTooltip, FormInputError },
  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      },
    },
    tooltipContent: {
      type: String,
      default: '',
    },

    tooltipLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="postcss" scoped>
.form-element {
  margin-bottom: 35px;
}

.form-element__tooltip {
  margin-top: var(--spacing-1);
}

.form-element__errors {
  margin: var(--spacing-1) 0 0;
}
</style>
